import { createAction } from '@poa/state';

// fetching
export const fetch = createAction('staff/fetch', () => ({}));
export const fetchSuccess = createAction('staff/fetchSuccess', (data, meta) => ({
  data,
  meta
}));
export const fetchFailed = createAction('staff/fetchFailed', () => ({}));
export const refreshStaff = createAction(
  'staff/refresh',
  (page = 1, search = '', filter = null, filters = []) => ({    page, search, filter, filters  })
);
// ui
export const toggleFavorite = createAction('staff/toggleFavorite', id => ({ id }));

export const setDates = createAction('staff/setDates', ({ startDate, endDate }) => ({
  startDate,
  endDate
}));

export const changeFiltering = createAction(
  'staff/changeFiltering',
    filtering => ({ filtering })
);
export const resetFilteringOptions = createAction('staff/resetFilteringOptions', filtering => ({
  filtering
}));

// presets
export const saveColumnPreset = createAction(
  'staff/saveColumnPreset',
  (preset, availablePresets) => ({
    preset,
    availablePresets
  })
);
export const deletePreset = createAction('staff/deletePreset', id => ({ id }));
export const changeColumnPreset = createAction('staff/changeColumnPreset', presetId => ({
  presetId
}));
export const changeColumnVisibility = createAction('staff/changeColumnVisibility', column => ({
  column
}));
export const toggleAllColumns = createAction('staff/toggleAllColumns', () => ({}));

export const resetColumnSettings = createAction(
  'staff/resetColumnSettings',
  ({ availablePresets, presetId }) => ({
    availablePresets,
    presetId
  })
);

export const changePresetOrder = createAction('staff/changePresetOrder', columns => ({
  columns
}));

export const changeRounding = createAction('staff/changeRounding', isDecimal => ({ isDecimal }));
export const changeSearch = createAction('staff/changeSearch', searchClause => ({
  searchClause
}));
